import { combineReducers } from 'redux'
import navigationReducer from './core/navigation_reducer'

const rootReducer = combineReducers({
  navigation: navigationReducer,
})

export default rootReducer
